export default __webpack_public_path__ + "static/media/francheville34.9ab0f566.jpg";